<template>
  <LayoutHeader main="index" ref="layout" :loadingOverlay="loadingOverlay" :me="me" :lastApp="lastApp" :appHistory="appHistory">
    <article>
      <div class="banners" v-if="apps">
        <router-link v-for="path of paths" class="banner" :to="{ name: 'App', params: { app: path }}" :style="{ 'background-image': 'linear-gradient(rgba(0,0,0,0.6),rgba(0,0,0,0.6)),url(' + util.variant(apps[path].rectangle, 'w=1920') + ')' }">
          <div class="bannerInner" :style="{ 'background-image': 'url(' + util.variant(apps[path].rectangle, 'w=1920') + ')' }">
          </div>
        </router-link>

      </div>
    </article>
  </LayoutHeader>
  <a v-if="apps" class="popUpEntry portraitHidden landscapeHidden" target="_blank" href="https://corporate.tapfun.co.jp/for_publishers">
    <span>
      <strong style="font-size: 20px">ゲームタイトルエントリー受付中</strong><br />
      プラットフォーム手数料：<span style="font-size: 16px; font-weight: 700">１８％</span> <span style="font-size: 12px">(クラウド費用込み)</span>
    </span>
  </a>
  
</template>

<script>
import baseMixin from './base'

export default {
  mixins: [
    baseMixin,
  ],
  data () {
    return {
      titlePrefix: 'TapFun',
      titleSuffixSeparator: ' | ',
      titleSuffix: 'クラウドゲーミングプラットフォームのタップファン',
    };
  },
  methods: {
  },
}
</script>

